import { createContext, useContext, useEffect, useState } from "react";
import { watchAuth, signOut as doSignOut } from "../../firebase/auth.js";
import { isConfigured } from "../../firebase/init.js";

const AuthContext = createContext({ user: null, loading: true, configured: false });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = watchAuth((u) => {
      setUser(u);
      setLoading(false);
    });
    return unsub;
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, loading, configured: isConfigured, signOut: doSignOut }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
